import React from "react";
import Customers from "../components/CustomerSection";
import Seo from "../components/Seo";
import AbsencesVideo from "../views/Absences/Video";
import AbsencesFeatures from "../views/Absences/Features";
import AbsencesHero from "../views/Absences/Hero";
import AbsencesMoreToKnow from "../views/Absences/MoreToKnow";
import AbsencesPricings from "../views/Absences/Pricing";
import { clients } from "../data";

const customers = clients.filter((c) => c.produits.includes("Absences"));

const AbsencesPage = () => {
  return (
    <React.Fragment>
      <Seo title="Innovance Absences" />
      <AbsencesHero />
      <AbsencesFeatures />
      <AbsencesVideo />
      <AbsencesMoreToKnow />
      <Customers customers={customers} />
      <AbsencesPricings />
    </React.Fragment>
  );
};

export default AbsencesPage;
